import { CircleCheck, TriangleAlert, ClipboardList } from "lucide-react";
import { Section, FieldError } from "@/components/common";
import { isConform } from "@/lib/questionDraw";

const AnswerButton = ({ q, idx, val, label, a, onAnswer }) => {
  const picked = a === val;
  const ok = picked && isConform(q, val);
  const cls = !picked ? "border-border bg-background text-slate-300 hover:border-slate-500"
    : ok ? "border-emerald-400 bg-emerald-950/70 text-emerald-200" : "border-red-500 bg-red-950/80 text-red-100";
  return (
    <button type="button" data-testid={`question-${idx + 1}-${val}`} aria-pressed={picked} onClick={() => onAnswer(q.id, val)}
      className={`inline-flex min-h-[48px] flex-1 items-center justify-center gap-2 rounded-md border-2 px-4 text-base font-bold transition-colors sm:flex-none sm:min-w-[110px] ${cls}`}>
      {picked && (ok ? <CircleCheck className="h-5 w-5" /> : <TriangleAlert className="h-5 w-5" />)} {label}
    </button>
  );
};

export const Questions = ({ questions, answers, errors, onAnswer }) => (
  <Section title="Préparation" icon={ClipboardList} testId="take5-questions-section">
    <ol className="space-y-3">
      {questions.map((q, idx) => {
        const key = `answers.${q.id}`;
        const a = answers[q.id];
        const bad = a && !isConform(q, a);
        return (
          <li key={q.id} data-field={key} data-testid={`question-${idx + 1}`} className={`rounded-lg border p-3 sm:p-4 ${errors[key] || bad ? "border-red-500/70 bg-red-950/20" : "border-border bg-background/40"}`}>
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
              <p className="font-medium" data-testid={`question-${idx + 1}-text`}><span className="mr-2 font-data text-amber-400">{idx + 1}.</span>{q.text}</p>
              <div className="flex gap-2">
                <AnswerButton q={q} idx={idx} val="oui" label="OUI" a={a} onAnswer={onAnswer} />
                <AnswerButton q={q} idx={idx} val="non" label="NON" a={a} onAnswer={onAnswer} />
              </div>
            </div>
            {bad && !errors[key] && <p data-testid={`question-${idx + 1}-alert`} className="mt-2 text-sm text-red-300">Réponse non conforme : la tâche ne pourra pas être autorisée. Faites lever ce point ou arrêtez le travail.</p>}
            <FieldError error={errors[key]} testId={`question-${idx + 1}-error`} />
          </li>
        );
      })}
    </ol>
  </Section>
);
